import React, { FC } from 'react'

//* utils
import { ModuleNames } from '../../../../../../constants/componentNames.constants'
import {
  FacebookNewsroom,
  LinkedinNewsroom,
  TwitterNewsroom,
} from '../../../../../../constants/svg'
import { SOCIAL, UIPATH } from '../../../../../../constants/urls'
import { renderRichText } from '../../../../../../utils/richTextHandler.utils'

//* components
import ContentBlock from '../../../../../global/contentBlock'
import Tiles from '../../../../../global/tiles'

type Props = {
  title: string
  slug: string
  body: string
  pressReleaseBoilerPlate: any
}

export const PostContent: FC<Props> = ({ title, slug, body, pressReleaseBoilerPlate }) => {
  let boilerPlate = []
  if (pressReleaseBoilerPlate?.contentEntries?.length) {
    const entries = pressReleaseBoilerPlate.contentEntries

    for (let i = 0; i < entries?.length; i++) {
      if (entries[i].__typename === ModuleNames.GLOBAL_CONTENT_BLOCK) {
        boilerPlate.push(<ContentBlock key={`pressReleaseBoilerPlate-${i}`} data={entries[i]} />)
      } else if (entries[i].__typename === ModuleNames.TILES) {
        boilerPlate.push(<Tiles key={`pressReleaseBoilerPlate-${i}`} data={entries[i]} />)
      }
    }
  }

  const twitterLink = title
    ? `${
        SOCIAL.TWITTER
      }/intent/tweet?original_referer=https%3A%2F%2Fwww.uipath.com%2F&ref_src=twsrc%5Etfw&text=${title
        .split(' ')
        .join('+')}&tw_p=tweetbutton&url=${UIPATH.PROD}/${slug}`
    : ''

  const linkedinLink = title
    ? `${SOCIAL.LINKEDIN}/shareArticle?mini=true&url=${UIPATH.PROD}/${slug}&title=text=${title
        .split(' ')
        .join('%20')}&summary=${title.split(' ').join('%20')}&source=https%3A%2F%2Fwww.uipath.com`
    : ''

  const facebookLink = `${SOCIAL.FACEBOOK}/sharer/sharer.php?u=${UIPATH.PROD}/${slug}&display=popup&ref=plugin&src=like&kid_directed_site=0`

  return (
    <div className="NewsroomPost__Post-Container">
      <div className="NewsroomPost__SocialMedia-Container">
        <a className="NewsroomPost__SocialMedia-Item" target="_blank" href={twitterLink}>
          <TwitterNewsroom />
        </a>

        <a className="NewsroomPost__SocialMedia-Item" target="_blank" href={linkedinLink}>
          <LinkedinNewsroom />
        </a>

        <a className="NewsroomPost__SocialMedia-Item" target="_blank" href={facebookLink}>
          <FacebookNewsroom />
        </a>
      </div>

      <div className="NewsroomPost__Body-Container">
        <div className="NewsroomPost__Body">{body && renderRichText(body)}</div>
        {boilerPlate}
      </div>
    </div>
  )
}
